import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[commaSeparatedWithTwoDecimals]',
  providers: [DecimalPipe],
})
export class CommaSeparatedWithTwoDecimalDirective {
  inputElement: HTMLInputElement;
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
  ];
  forecastValue: any;

  constructor(
    private el: ElementRef,
    private model: NgControl,
    private decimal: DecimalPipe
  ) {
    this.inputElement = el.nativeElement;
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      ((e.key === 'a' || e.code === 'KeyA') && e.ctrlKey === true) || // Allow: Ctrl+A
      ((e.key === 'c' || e.code === 'KeyC') && e.ctrlKey === true) || // Allow: Ctrl+C
      ((e.key === 'v' || e.code === 'KeyV') && e.ctrlKey === true) || // Allow: Ctrl+V
      ((e.key === 'x' || e.code === 'KeyX') && e.ctrlKey === true) || // Allow: Ctrl+X
      ((e.key === 'a' || e.code === 'KeyA') && e.metaKey === true) || // Allow: Cmd+A (Mac)
      ((e.key === 'c' || e.code === 'KeyC') && e.metaKey === true) || // Allow: Cmd+C (Mac)
      ((e.key === 'v' || e.code === 'KeyV') && e.metaKey === true) || // Allow: Cmd+V (Mac)
      ((e.key === 'x' || e.code === 'KeyX') && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }
  }

  @HostListener('input', ['$event'])
  onInput(): void {
    const inputValue = this.el.nativeElement.value.replace(/,/g, '');
    const decimalIndex = inputValue.indexOf('.');
    let integerPart = inputValue.slice(
      0,
      decimalIndex !== -1 ? decimalIndex : inputValue.length
    );
    const decimalPart = inputValue.slice(
      decimalIndex !== -1 ? decimalIndex + 1 : inputValue.length
    );

    // Remove leading zeros
    integerPart = integerPart.replace(/^0+/, '');

    // Add thousand comma separator
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Restrict decimal part to two digits
    const restrictedDecimalPart = decimalPart.slice(0, 2);

    // Update the input value
    this.el.nativeElement.value =
      decimalIndex !== -1
        ? `${integerPart}.${restrictedDecimalPart}`
        : integerPart;
  }
}
